import { container } from "tsyringe";
export class UseCaseGetOffersById {
    constructor() {
        this.handle = async (id) => {
            return this._getOffersById.handle(id);
        };
        this._getOffersById = container.resolve("iUseCaseGetOffersById");
    }
}
